<template>
  <div v-if="is_h5 == false">
    <pheader></pheader>
    <el-container class="pc_detail_main">
      <el-main>
        <el-row>
          <el-col :span="detailSpan">
            <div class="pc_col-content">
              <div class="pc_detail-content" ref="pc_detail-content">
                <div style="float: left;">
                  <div v-if="item.atta_url">
                    <el-row style="height: 300px;" :style="{width:leftDivWidth}">
                      <el-col :span="24">
                        <player-video v-if="item.atta_url" :src="getFileSource(item.atta_url)" :img="getFileSource(item.cover_image)"></player-video>
                      </el-col>
                    </el-row>
                  </div>
                  <div v-else-if="item.kc_url">
                    <el-row style="height: 300px;">
                      <el-col :span="24">
                        <div style="float: left;">
                          <el-image v-if="item.cover_image" style="height: 300px;" :src="getImageSource(item.cover_image)" fit="contain"></el-image>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div style="float: left; /* width: 250px;*/" v-if="!loadingItem">
                  <h2 style="margin-top: 10px; margin-left: 15px;"><b>{{ item.name }}</b></h2>
                  <div style="margin-top: 10px; margin-left: 15px;">
                    <span><van-icon name="user-o" class="h5_custom-icon"/>{{ ' ' + (item.username || item.sys_username) }}</span>
                  </div>
                  <div style="margin-top: 10px; margin-left: 15px;">
                    <span><van-icon name="newspaper-o"  class="h5_custom-icon"/>{{ ' ' + (item.orgname.split('/')[item.orgname.split('/').length -1] || item.sys_org_name && item.sys_org_name.split('/')[0]) }}</span>
                  </div>
                  <div style="margin-top: 10px; margin-left: 15px;" v-if="item.kc_url">
                    <el-button type="danger" @click="openUrl(item.kc_url)">查看课程</el-button>
                  </div>
                </div>
              </div>
              <el-scrollbar wrap-style="overflow-x:hidden;" style="clear: both;">
                <div style="height: calc(100vh - 540px);">
                  <div v-for='(detailContent, idx) in item.kechengxiangqing' :key="idx" :label="idx">
                    <div v-if="detailContent && detailContent.length > 0">
                      <h3><b><van-icon name="wap-home"/>{{ dictInfo[idx] || getDictInfo(idx) }}</b></h3>
                      <div class="pc_text-content" v-html="detailContent"></div>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
  <div v-else>
    <van-row>
      <van-col span="24">
        <van-nav-bar
          :title="title"
          left-text="返回"
          left-arrow
          @click-left="onClickLeft"
        />
      </van-col>
    </van-row>
    <van-row style="height: calc(30vh);" v-if="!loadingItem">
      <van-col span="24" v-if="item.atta_url">
        <div class="h5_video-content">
          <player-video v-if="item" :src="getFileSource(item.atta_url)" :img="getImageSource(item.cover_image)"></player-video>
        </div>
      </van-col>
      <van-col span="24" v-else-if="item.kc_url">
        <div class="h5_video-content">
          <van-image
            :src="getImageSource(item.cover_image)"
          />
        </div>
      </van-col>
    </van-row>
    <van-row v-if="!loadingItem">
      <van-col span="24">
        <div class="h5_container">
          <div class="h5_text-content">
            <h3><b>{{ item.name }}</b></h3>
            <div>
              <span ><van-icon name="user-o" class="h5_custom-icon"/>{{ ' ' + (item.username || item.sys_username) }}</span>
            </div>
            <div>
              <span ><van-icon name="newspaper-o"  class="h5_custom-icon"/>{{ ' ' + (item.orgname.split('/')[item.orgname.split('/').length -1] || item.sys_org_name && item.sys_org_name.split('/')[0]) }}</span>
            </div>
            <van-button v-if="item.kc_url" type="danger" size="small" @click="openUrl(item.kc_url)">查看课程</van-button>
          </div>
          <div class="h5_text-content" v-for='(detailContent, idx) in item.kechengxiangqing' :key="idx" :label="idx">
            <div v-if="detailContent && detailContent.length > 0">
              <h3><van-icon name="wap-home"/>{{ dictInfo[idx] || getDictInfo(idx) }}</h3>
              <div v-html="detailContent"></div>
            </div>
          </div>
          
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import {showNotify} from 'vant';
import pheader from "@/views/pheader.vue";
import playerVideo from "@/components/player-video.vue";

export default {
  name: 'searchDetail',
  components: {
    pheader,
    playerVideo
  },
  props: {

  },
  setup() {
    const apiUrls = {
      'getSearchPageData':'/onlineCodeService/jxzysjfl_api/loadSearchPageData',
      'getDictInfoByDictCode':'/onlineCodeService/jxzysjfl_api/getDictInfoByDictCode',
      'loadRecommendedReadingApi':'/onlineCodeService/jxzysjfl_api/loadRecommendedReading',
      'startAddUpReadCountApi':'/onlineCodeService/jxzysjfl_api/startAddUpReadCount',
    };
    return {
      apiUrls
    };
  },
  data(){
    return {
      is_h5: this.$utils.checkScreenSize(),
      title:'',
      item:'',
      dictInfo:{},
      loadingItem:true,
      activeName:'推荐阅读',
      tjydItems:[],
      tjydLoading:false,
      detailSpan: 24,
      tjydSpan:8,
      tjydSpanContent:12,
      isShow: true,
      screenWidth:window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      leftDivWidth: '1000px'
    }
  },
  created() {
      this._id = this.$route.query._id;
      this.title = this.$route.query.title;
      this.loadData()
      if (this.screenWidth < 1390){
        this.tjydSpanContent = 24
      }
  },
  methods:{
    loadData(){
      this.getItem()
    },
    toggleMediaDisplay(obj){
      let routeUrl = this.$router.resolve({
        path: "/Detail",
        query: {
          _id:obj._id, 
          title:obj.name
        }
      });
      if (this.is_h5){
        this._id = obj._id,
        this.title = obj.name
        this.loadData()
        //window.location.href = routeUrl.href
      }else{
        window.open(routeUrl.href, '_blank');
      }
    },
    handleClick(tab, event){
      console.log(tab, event)
    },
    openUrl(url){
      this.$utils.openCourseUrl(url, this.item && this.item.kc_source);
    },
    onClickLeft(){
      // this.$router.go(-1)
      this.$router.push('/');
    },
    getItem(){
      this.loadingItem = true
      let param = {}
      param['QueryObject'] = {
        'searchDict':{'searchValue': this._id}
      }
      this.$http.post(this.apiUrls.getSearchPageData, param).then(res => {
        this.loadingItem = false
        if ('0' == res.resultCode) {
          let resultData = res.resultData['DataList'];
          if (resultData.length > 0){
            this.item = resultData[0]
            console.log(this.item)
            this.startAddUpReadCount(this.item['_id'])
            this.loadRecommendedReading()
          }
        } else {
          console.log(res)
        }
      }).catch(error => {
        showNotify('请求失败，请稍后再试！')
        console.log(error)
        console.log('失败')
      })
    },
    startAddUpReadCount(_id){
      let param = {}
      param['_id'] = _id
      this.$http.post(this.apiUrls.startAddUpReadCountApi, param).then(res => {
        if ('0' == res.resultCode) {
          console.log(1)
        } else {
          console.log(res)
        }
      }).catch(error => {
        console.log(error)
        console.log('失败')
      })
    },
    getFileSource(url){
      return window.baseURL + url
    },
    getImageSource(img){
      if (undefined != img && !img.startsWith("http")){
        return this.$utils.getImageSource(img)
      }else{
        return img
      }
    },
    getPlayerWidthByScreenWidth(){
      this.$nextTick(() => {
        // 使用 $refs 访问元素
        let leftDiv = this.$refs['pc_detail-content'];
        // 获取元素的宽度
        const _width = leftDiv.clientWidth - 250 - 10;
        this.leftDivWidth = _width + 'px'
      });
    },
    getDictInfo(dict_code){
      let param = {"dict_code": dict_code}
      this.$http.post(this.apiUrls.getDictInfoByDictCode, param).then(res => {
        if ('0' == res.resultCode) {
          let resultData = res.resultData;
          let dict_name = resultData['dict_name']
          this.dictInfo[dict_code] = dict_name
        } else {
          console.log(res)
        }
      }).catch(error => {
        showNotify('请求失败，请稍后再试！')
        console.log(error)
        console.log('失败')
      })
    },
    loadRecommendedReading() {
      // 获取推荐阅读数据
      this.tjydLoading = true
      let param = {'_id': this.item._id}
      this.$http.post(this.apiUrls.loadRecommendedReadingApi, param).then(data => {
        this.tjydLoading = false
        if ('0' == data.resultCode) {
          this.tjydItems = data.resultData;
          if (this.tjydItems.length == 0){
            this.tjydSpan = 0
            this.detailSpan = 24
          }
        } else {
          showNotify(data.resultMsg)
        }
      }).catch(error => {
        this.tjydLoading = false
        console.log(error)
        console.log('获取数据失败！')
      })
    },
  },
  mounted(){
    if (this.is_h5 == false){
      this.getPlayerWidthByScreenWidth()
    }
  },
  watch: {
    title: {
      handler() {
        // 在 searchParam 变化时执行的操作
        console.log(this.title)
        this.loadData();
      }
    }
  }

};
</script>
<style scoped>
.pc_detail_main{
  height: calc(100vh - 160px);
  background-color: #f6f6f6;
}

.pc_col-content {
  max-width: 80%; /* 设置内容区域最大宽度 */
  margin: 0 auto; /* 自动左右边距实现居中 */
  margin-top: 10px;
  padding-left: 5px;
  padding-right: 5px;

}

.pc_text-content {
    color: #969799;
    padding-left: 20px;
    padding-right: 20px;
  }
.content {
  height: calc(100Vh - 260px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
<style scoped>
  .h5_container {
    height: calc(100vh - 46px - 30vh); /* 设置容器高度 */
    overflow-y: auto; /* 启用垂直滚动 */
  }
  .h5_video-content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .h5_text-content {
    color: #969799;
    padding-left: 20px;
    padding-right: 20px;
  }

  .h5_text-content div{
    font-size: 14px; 
    margin-top: 10px;
  }

  .h5_custom-icon {
    color: #007bff; /* 图标的颜色，可以根据需要调整 */
  }

  .underline {
    border-bottom: 1px dashed #CCC;; /* 黑色虚线 */
  }
</style>
